import React from 'react';
import Modal from './modal';
import { Button } from './button';
import { LogOut } from 'lucide-react';
import { t } from 'i18next';

interface LogoutConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const footer = (
    <>
      <Button 
        type="button"
        onClick={onClose}
        variant="outline"
        className="border-gray-300 dark:border-gray-700"
      >
        {t('logoutConfirmationModal.cancel', 'Annuler')}
      </Button>
      <Button 
        type="button"
        onClick={handleConfirm}
        className="bg-red-500 hover:bg-red-600 text-white"
      >
        <LogOut size={16} className="mr-2" />
        {t('logoutConfirmationModal.logout', 'Déconnexion')}
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('logoutConfirmationModal.title', 'Confirmation de déconnexion')}
      footer={footer}
      size="sm"
    >
      <div className="flex flex-col items-center text-center space-y-4">
        <div className="w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
          <LogOut size={28} className="text-red-500 dark:text-red-400" />
        </div>
        <p className="text-gray-700 dark:text-gray-300">
          {t('logoutConfirmationModal.description', 'Êtes-vous sûr de vouloir vous déconnecter ?')}
        </p>
      </div>
    </Modal>
  );
};

export default LogoutConfirmationModal;
